import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export function FeaturedPartner() {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/partners/featured").then(({ data }) => setP(data)).catch(() => {});
  }, []);
  if (!p) return null;
  return (
    <Link to={`/partner#${p.id}`} data-testid="cafe-featured-partner" className="group absolute bottom-6 left-4 z-10 flex max-w-[16rem] items-center gap-3 rounded-2xl border border-fuchsia-300/40 bg-[#1c1220]/85 p-3 text-white shadow-[0_0_24px_rgba(232,121,249,.25)] backdrop-blur-xl transition-[transform,box-shadow] hover:-translate-y-0.5 hover:shadow-[0_0_32px_rgba(232,121,249,.45)] sm:left-6">
      <img src={p.logo_url} alt="" className="h-12 w-12 shrink-0 rounded-xl bg-white object-contain p-1" />
      <span className="min-w-0">
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.2em] text-fuchsia-300"><Award className="h-3 w-3" />Partner del mese</span>
        <span className="block truncate text-sm font-bold">{p.name}</span>
        <span className="flex items-center text-[11px] text-slate-300">Vedi la scheda <ChevronRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" /></span>
      </span>
    </Link>
  );
}
